import type { ReactNode } from 'react'

export interface FeatureAnnouncementMedia {
  /** Vídeo (webm) em `public/` — nunca URL vinda do back. */
  src: string
  /** Quadro estático: poster do vídeo (é o que aparece sob `prefers-reduced-motion`). */
  poster: string
  /** Descrição acessível do que o vídeo mostra. */
  alt: string
}

export interface FeatureAnnouncementStep {
  /** Uma linha: a lista inteira fica visível acima do vídeo. */
  text: ReactNode
  /** Segundo do vídeo em que o passo começa (`scripts/novidades/record.mjs` imprime). */
  start: number
}

export interface FeatureAnnouncement {
  /** UM vídeo contínuo com o fluxo inteiro; os passos são legendas sincronizadas. */
  media: FeatureAnnouncementMedia
  steps: readonly FeatureAnnouncementStep[]
}

const BASE = '/novidades/marcar-nao-lida'

/**
 * Catálogo LOCAL das novidades, por `feature_key`. O back só manda a chave; o
 * conteúdo rico (vídeo e passos) sai daqui. Chave que não estiver aqui cai no
 * `title`/`body` de fallback do back.
 */
export const FEATURE_ANNOUNCEMENTS: Readonly<Record<string, FeatureAnnouncement>> = {
  'marcar-nao-lida': {
    media: {
      src: `${BASE}/fluxo.webm`,
      poster: `${BASE}/fluxo.png`,
      alt: 'Botão direito numa conversa da lista lateral abre o menu; Marcar como não lida pede confirmação e, confirmado, a conversa ganha o destaque ciano.',
    },
    steps: [
      { text: 'Clique com o botão direito na conversa, na lista lateral.', start: 0 },
      {
        text: (
          <>
            Escolha <strong>Marcar como não lida</strong> e confirme.
          </>
        ),
        start: 2.72,
      },
      { text: 'A conversa ganha o destaque ciano para o time até alguém abri-la.', start: 7.29 },
    ],
  },
}
